import {
    RESET_EDITPROFILE,
    RESET_ERROR,
    API_ERROR,
    GET_EDITPROFILE,
    SET_EDITPROFILE,
    EDIT_EDITPROFILE,
    EDIT_EDITPROFILE_SUCCESS,
  } from "./actionTypes";
  
  const initialState = {
    errorEditProfile: false,
    loadingEditProfile: false,
    dataEditProfile: null,
    successEditProfile: false,
  };
  
  const EditProfile = (state = initialState, action) => {
    switch (action.type) {      
      case RESET_EDITPROFILE:
        state = {
          ...state,
          errorEditProfile: false,
          loadingEditProfile: false,
          successEditProfile: false,
          dataEditProfileGetSet: null,
          dataEditProfileEditCreate: null,
        };
        break;
      case RESET_ERROR:
        state = {
          ...state,
          errorEditProfile: false,
          loadingEditProfile: false,
          loadingEditProfileEditCreate: false,
          successEditProfile: false,
        };
        break;     
      case GET_EDITPROFILE:
        state = {
          ...state,
          errorEditProfile: false,
          loadingEditProfile: true,
          dataEditProfileGetSet: null,
        };
        break;
      case SET_EDITPROFILE:
        state = {
          ...state,
          errorEditProfile: false,
          loadingEditProfile: false,
          dataEditProfileGetSet: action.payload,
        };
        break;
      case EDIT_EDITPROFILE:
        state = {
          ...state,
          errorEditProfile: false,
          loadingEditProfileEditCreate: true,
          dataEditProfileEditCreate: action.payload,
          successEditProfile: false,
        };
        break;
      case EDIT_EDITPROFILE_SUCCESS:
        state = {
          ...state,
          errorEditProfile: false,
          loadingEditProfileEditCreate: false,
          dataEditProfileEditCreate: action.payload,
          successEditProfile: true,
        };
        break;
      case API_ERROR:
        state = {
          ...state,
          errorEditProfile: action.payload,
          loadingEditProfile: false,
          loadingEditProfileDelete: false,
          successEditProfile: false,
        };
        break;     
      default:
        // state = { ...state, errorEditProfile: false, loadingEditProfile: false };
        break;
    }
    return state;
  };
  
  export default EditProfile;
  